<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto" />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">登录</h4>
                  <p>欧城记小程序管理后台</p>
                </div>

                <form>
                  <vs-input name="username" placeholder="用户名" icon-no-border icon="icon icon-user" icon-pack="feather"
                    v-model="username" class="w-full" :disabled="disabled" />

                  <vs-input type="password" name="password" placeholder="密码" icon-no-border icon="icon icon-lock"
                    icon-pack="feather" v-model="password" @keyup.enter.native="login" class="w-full mt-6" autocomplete :disabled="disabled" />

                  <div class="flex flex-wrap justify-between my-5">
                    <!-- <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox> -->
                    <router-link to>忘记密码?</router-link>
                  </div>
                  <vs-button @click="login()" :disabled="disabled">登录</vs-button>
                  <vs-button class="float-right" type="border" @click="gotoRegister()" :disabled="disabled">注册
                  </vs-button>

                </form>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
  import Utils from '@/utils/utils'
  import {
    mapMutations
  } from 'vuex'
  export default {
    name: 'Login',
    data() {
      return {
        username: '',
        password: '',
        disabled: false
      }
    },
    mounted() {
      // const userInfo = this.$store.state.userInfo
      // if (userInfo) {
      //   this.$router.push('/')
      // }
    },
    methods: {
      ...mapMutations(['ADD_USER_INFO', 'ADD_USER_TOKEN']),
      login() {
        let data = {
          username: this.username,
          password: this.password
        }
        data = JSON.stringify(data)
        data = Utils.encrypt(data)
        this.disabled = true
        this.$auth.login({
          params: {
            data: data
          },
          success: res => {
            this.disabled = false
            // console.log('res', res.data)
            const data = res.data.data //加密str
            // console.log('data:::::::', data)
            this.openNotify('登录成功!', 'success')
            let userInfo = Utils.decrypt(data)
            userInfo = JSON.parse(userInfo)
            this.ADD_USER_INFO(userInfo)
            const token = res.headers.authorization
            const userToken = 'Bearer ' + token
            // console.log('user token:', userToken)
            this.ADD_USER_TOKEN(userToken)

            // setTimeout(() => {
            //   this.$router.push({
            //     path: '/'
            //   })
            // }, 1200)
          },
          error: error => {
            this.disabled = false
            const resp = error + ''
            const missCode = 408 + ''
            if (resp.includes(missCode)) {
              this.openNotify('用户名或密码输入错误')
            } else {
              this.openNotify('登录错误, 请稍后重试')
            }
          }
        })
      },

      openNotify: function (msg, color = 'danger') {
        this.$vs.notify({
          position: 'bottom-center',
          color: color,
          title: '操作提示',
          text: msg
        })
      },

      gotoRegister: function () {
        this.$router.push({
          path: '/register'
        })
      }
    }
  }

</script>

<style lang="scss">
  #page-login {
    .social-login-buttons {
      .bg-facebook {
        background-color: #1551b1;
      }

      .bg-twitter {
        background-color: #00aaff;
      }

      .bg-google {
        background-color: #4285f4;
      }

      .bg-github {
        background-color: #333;
      }
    }
  }

</style>
